import React from 'react';
import { Divider } from 'primereact/divider';

const SectionHeader = ({ title, subtitle, className = '' }) => {
  return (
    <div className={`mt-10 mb-6 text-center ${className}`}>
      <h4 className="text-xl md:text-2xl font-bold text-base-content mb-2">{title}</h4>
      {subtitle && <p className="text-base-content/70 text-sm mb-4">{subtitle}</p>}
      <Divider type="dashed" />
    </div>
  );
};

export default SectionHeader;
